import { useAppSelector } from "./redux";
import { Themes, ConfigCatFeatureFlag } from "../util/CommonConstant";
import defaultLogo from "../asset/img/logos/logo.svg";
import { isValidHttpUrl } from "../util/CommonUtil";
import useDarkMode from "./useDarkMode";

// Default whitelabel values
const DEFAULT_WHITELABEL = {
  logoUrl: defaultLogo,
  tagLine: `Get started\nwith Hawkeye!`,
  productName: "Hawkeye",
  authLogoHeight: "90",
  sideBarLogoHeight: "48",
  menuTagline: "",
  overrideFavicon: "",
};

export default function useIsWhitelabelled(): {
  logoUrl: string;
  tagLine: string;
  productName: string;
  authLogoHeight: string;
  sideBarLogoHeight: string;
  menuTagline: string;
  overrideFavicon?: string;
} {
  const org = useAppSelector((state) => state.common.org);
  const whitelabelFlag = useAppSelector(
    (state) => state.configCat[ConfigCatFeatureFlag.whitelabeling]
  );

  // Always call useDarkMode to maintain hooks order
  const isDarkMode = useDarkMode();

  // Try to parse the feature flag as JSON
  let flagObj: any = undefined;
  if (whitelabelFlag && typeof whitelabelFlag === "string") {
    try {
      flagObj = JSON.parse(whitelabelFlag);
    } catch (e) {
      // ignore parse error
    }
  } else if (whitelabelFlag && typeof whitelabelFlag === "object") {
    flagObj = whitelabelFlag;
  }

  // If feature flag is valid and has required fields, use it
  if (flagObj && flagObj.logoUrl && flagObj.tagLine && flagObj.productName) {
    return {
      logoUrl: isValidHttpUrl(flagObj.logoUrl) ? flagObj.logoUrl : DEFAULT_WHITELABEL.logoUrl,
      tagLine: flagObj.tagLine,
      productName: flagObj.productName,
      authLogoHeight: flagObj.authLogoHeight,
      sideBarLogoHeight: flagObj.sideBarLogoHeight,
      menuTagline: flagObj.menuTagline,
      overrideFavicon: flagObj.overrideFavicon,
    };
  }

  // Fallback to org-based values
  let logoUrl = DEFAULT_WHITELABEL.logoUrl;
  if (org) {
    if (isDarkMode && org.logo_url_dark) logoUrl = org.logo_url_dark;
    else if (!isDarkMode && org.logo_url_light) logoUrl = org.logo_url_light;
  }
  return {
    logoUrl,
    tagLine: org?.tagLine || DEFAULT_WHITELABEL.tagLine,
    productName: org?.productName || DEFAULT_WHITELABEL.productName,
    authLogoHeight: org?.authLogoHeight || DEFAULT_WHITELABEL.authLogoHeight,
    sideBarLogoHeight: org?.sideBarLogoHeight || DEFAULT_WHITELABEL.sideBarLogoHeight,
    menuTagline: org?.menuTagline || DEFAULT_WHITELABEL.menuTagline,
    overrideFavicon: org?.overrideFavicon || DEFAULT_WHITELABEL.overrideFavicon,
  };
}
